<ion-card-content class="ion-no-padding" >
  <div class="new-comment" >
    <ion-item lines="none" >
      <ion-label position="floating">
        {{ 'notepad.addComment' | translate | uppercase }}
      </ion-label>
      <ion-textarea
        [(ngModel)]="currentNote.text"
        [placeholder]="'generic.writeToReply' | translate"
      ></ion-textarea>
    </ion-item>
    <div class="actions" >
      <p class="cancel"
        (click)="setNewNote()" >
        {{ currentNote.id ? ('notepad.cancelEdit' | translate) : '' }}
      </p>
      <ion-button color="primary" mode="ios"
        [disabled]="!currentNote.text"
        (click)="saveNote(currentNote)" >
        {{ 'generic.save' | translate }}
      </ion-button>
    </div>
  </div>

  <p class="empty" *ngIf="notes && notes.length === 0" >
    {{ 'notepad.noNotes' | translate }}
  </p>
  
  <ion-list class="users" *ngIf="currentUser && notes" >
    <ion-item *ngFor="let note of notes" lines="none" >
      <ion-avatar slot="start">
        <img [src]="getImageUrl(currentUser.imageUrl)" default="" >
      </ion-avatar>
      <p class="note" >
        <span class="title" >
          {{ currentUser.name }}
        </span>
        <span class="date" >
          {{ note.createdAt | date : 'dd/MM/yyyy' }}
        </span><br>
        {{ note.text }}
      </p>
      <ion-buttons>
        <ion-button color="primary" fill="clear" mode="ios"
          (click)="currentNote = note" >
          <ion-icon class="bp-edit" slot="end"></ion-icon>
        </ion-button>
        <ion-button class="delete" color="danger" fill="clear" mode="ios"
          (click)="confirmDeleteNote(note.id)" >
          <ion-icon class="bp-delete"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-item>
  </ion-list>
</ion-card-content>